import { Message } from 'element-ui'

// 消息提示
export function WLMessage(message = '服务器响应异常', type = 'warning') {
  Message({
    type: type,
    message
  });
}